module.exports = __webpack_public_path__ + "img/mp4_1.b756c8af.png";